// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import { useVaccineDashboardStore } from '../../../store/vaccineDashboardStore';
import { useVaccineModelWithBackend } from '../hooks/useVaccineModelWithBackend';
import { VaccineDashboardKPIs } from './VaccineDashboardKPIs';

/**
 * Connected wrapper component for VaccineDashboardKPIs
 * Uses backend results when available, falls back to frontend calculation
 */
export const VaccineDashboardKPIsConnected: React.FC = () => {
  const inputs = useVaccineDashboardStore((state) => state.inputs);
  const dashboardSettings = useVaccineDashboardStore((state) => state.dashboardSettings);
  const setDashboardSettings = useVaccineDashboardStore((state) => state.setDashboardSettings);
  
  const model = useVaccineModelWithBackend(inputs);

  return (
    <VaccineDashboardKPIs
      model={model}
      dashboardSettings={dashboardSettings}
      onSettingsChange={setDashboardSettings}
    />
  );
};
